import { useState } from "react";

/* A field that saves when it's left (or on Enter), not on every key: the text stays as typed
   while focus is in it, and follows the saved value whenever that changes. `save` gets the
   text only when it differs from what is saved. */
export function useSavedText(saved: string, save: (text: string) => void) {
  const [text, setText] = useState(saved);
  const [base, setBase] = useState(saved);
  if (saved !== base) {
    setBase(saved);
    setText(saved);
  }
  const commit = () => {
    if (text !== saved) save(text);
  };
  return {
    value: text,
    set: setText,
    onBlur: commit,
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        commit();
      }
    },
    /** Put the saved text back: one the server can't take. */
    reset: () => setText(saved),
  };
}
